import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cep-tracking',
    templateUrl: './cep-tracking.component.html',
    styleUrls: ['./cep-tracking.component.scss'],
    standalone: false
})
export class CepTrackingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
